import { createState, useState } from '@hookstate/core';
import Helper from '../utility/helper';
const initialState = {
    notificationCount: 0
};

const notificationState = createState(initialState);

export const setNotification = (props) => {    
    if (props) { 
        notificationState.set({
            ...initialState,
            notificationCount: props.notificationCount
        });
    }
    return;
};
export const useNotificationState = () => {
    return useState(notificationState);
};
export const exitTheme = () => {
    Helper.removeStorage('eventInfo');
    Helper.removeStorage('eventModuleConfig');
    notificationState.set(initialState);
};
